import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { HomepageComponent } from './features/homepage/homepage.component';
import { routes } from './app.routes';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { FaqComponent } from './features/dashboard/faq/faq.component';
import { HomeSalesRefinancingComponent } from './features/home-sales-refinancing/home-sales-refinancing.component';
import { BatterySolutionsComponent } from './features/battery-solutions/battery-solutions.component';
import { FormsComponent } from './features/dashboard/forms/forms.component';
import { MonitoringComponent } from './features/monitoring/monitoring.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { CareersComponent } from './features/careers/careers.component';
import { LicensesComponent } from './features/licenses/licenses.component';
import { ServiceChargesComponent } from './features/service-charges/service-charges.component';
import { FleetManagementComponent } from './features/fleet-management/fleet-management.component';
import { AboutComponent } from './features/about/about.component';
import { ProComponent } from './features/pro/pro.component';
import { PortalFaqComponent } from './features/dashboard/faq/portal-faq/portal-faq.component';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { PopUpComponent } from './features/dashboard/pop-up/pop-up.component';
import { NotificationBannerComponent } from './layout/notification-banner/notification-banner.component';
import { CommonModule, NgIf } from '@angular/common';
import { LifeEventsComponent } from './features/life-events/life-events.component';


@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    NgIf,
    HomepageComponent,
    NotificationBannerComponent,
    PopUpComponent,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    FaqComponent,
    HomeSalesRefinancingComponent,
    BatterySolutionsComponent,
    FormsComponent,
    MonitoringComponent,
    DashboardComponent,
    CareersComponent,
    LicensesComponent,
    ServiceChargesComponent,
    AboutComponent,
    ProComponent,
    PortalFaqComponent,
    LifeEventsComponent

  ],
})
export class AppComponent{}
